'use strict';

require("core-js/modules/es6.array.map");

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _configProvider = require('../../config-provider');

var _configProvider2 = _interopRequireDefault(_configProvider);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Button.Group
 */


var ButtonGroup = (_temp = _class = function (_Component) {
  (0, _inherits3["default"])(ButtonGroup, _Component);

  function ButtonGroup() {
    (0, _classCallCheck3["default"])(this, ButtonGroup);
    return (0, _possibleConstructorReturn3["default"])(this, _Component.apply(this, arguments));
  }

  ButtonGroup.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        prefix = _props.prefix,
        className = _props.className,
        size = _props.size,
        children = _props.children,
        rtl = _props.rtl,
        others = (0, _objectWithoutProperties3["default"])(_props, ['prefix', 'className', 'size', 'children', 'rtl']);
    var groupCls = (0, _classnames2["default"])((_classNames = {}, _classNames[prefix + 'btn-group'] = true, _classNames[className] = className, _classNames));

    var cloneChildren = _react.Children.map(children, function (child) {
      if (child) {
        return _react2["default"].cloneElement(child, {
          size: size
        });
      }
    });

    if (rtl) {
      others.dir = 'rtl';
    }

    return _react2["default"].createElement('div', (0, _extends3["default"])({}, others, {
      className: groupCls
    }), cloneChildren);
  };

  return ButtonGroup;
}(_react.Component), _class.propTypes = (0, _extends3["default"])({}, _configProvider2["default"].propTypes, {
  rtl: _propTypes2["default"].bool,
  prefix: _propTypes2["default"].string,

  /**
   * 统一设置 Button 组件的按钮大小
   */
  size: _propTypes2["default"].string,
  className: _propTypes2["default"].string,
  children: _propTypes2["default"].node
}), _class.defaultProps = {
  prefix: 'next-',
  size: 'medium'
}, _temp);
ButtonGroup.displayName = 'ButtonGroup';
exports["default"] = _configProvider2["default"].config(ButtonGroup);
module.exports = exports['default'];